import { NavigatorScreenParams } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import React from "react";

import Checkout from "@/screens/Checkout";
import GlobalSearch from "@/screens/Search/GlobalSearch";

import { AddressStack, AddressStackParamList } from "./stacks/AddressStack";
import CartStack, { CartStackParamList } from "./stacks/CartStack";
import HomeStack, { HomeStackParamList } from "./stacks/HomeStack";
import { OrderStack, OrderStackParamList } from "./stacks/OrderStack";
import { SettingsStack, SettingsStackParamList } from "./stacks/SettingsStack";

export type WebStackParamList = {
  homeStack: NavigatorScreenParams<HomeStackParamList>;
  addressStack: NavigatorScreenParams<AddressStackParamList>;
  settingsStack: NavigatorScreenParams<SettingsStackParamList>;
  cartStack: NavigatorScreenParams<CartStackParamList>;
  orderStack: NavigatorScreenParams<OrderStackParamList>;
  checkout: undefined;
  search: {
    query?: string;
  };
};

export const WebRoutePaths = {
  homeStack: "/",
  settingsStack: "ajustes",
  addressStack: "enderecos",
  cartStack: "carrinho",
  orderStack: "pedidos",
  checkout: "checkout",
  search: "busca",
};

const Web = createStackNavigator<WebStackParamList>();

const WebNavigator = () => {
  return (
    <Web.Navigator
      initialRouteName="homeStack"
      screenOptions={{ headerShown: false, headerMode: "screen" }}>
      <Web.Screen name="homeStack" component={HomeStack} options={{ title: "iFeira" }} />
      <Web.Screen name="settingsStack" component={SettingsStack} options={{ title: "Ajustes" }} />
      <Web.Screen
        name="addressStack"
        component={AddressStack}
        options={{ title: "Meus Endereços" }}
      />
      <Web.Screen name="cartStack" component={CartStack} options={{ title: "Carrinho" }} />
      <Web.Screen name="search" component={GlobalSearch} options={{ title: "Buscar" }} />
      <Web.Screen name="checkout" component={Checkout} options={{ title: "Checkout" }} />
      <Web.Screen name="orderStack" component={OrderStack} options={{ title: "Pedidos" }} />
    </Web.Navigator>
  );
};

export default WebNavigator;
